module.exports = __webpack_public_path__ + "img/wechat_out.cb3d7cf5.png";